<div class="snack-bar">
    <div class="profile">
        <img id="icon" src="/assets/images/icons/snackbar/add-currency.svg" alt="">
        <!-- <p>Currency is Added.</p> -->
        <p [innerHTML]="data.description"></p>

    </div>
</div>